import styled from 'styled-components';
import { Icon } from './../../../Icon';
import { COLORS, FONTS } from './../../../../ui';

export const Tooltip = styled.div`
  display: none;
  position: absolute;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  font-size: 14px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  color: ${COLORS.WHITE};
  line-height: 14px;
  padding: 4px 15px;
  left: 68px;
`;

export const ComponentWrapper = styled.div`
  display: inline-block;
  background: ${COLORS.WHITE};
  box-shadow: 0 1px 4px rgba(0,0,0,0.25);
  border-radius: 2px;
  font-size: 14px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  color: ${COLORS.TEXT_GRAY};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 9px 8px;
  position: relative;

  ${ComponentWrapper} {
    position: absolute;
    left: 60px;
    min-width: max-content;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  transition: .6s;
  position: relative;

  &:hover {
    background: rgba(0, 0, 0, 0.1);

    ${Tooltip} {
      display: block;
    }
  }
`;

export const IconSelected = styled.div`
  position: absolute;
  right: -28px;
  width: 0;
  height: 0;
  border-top: 16px solid transparent;
  border-right: 16px solid ${COLORS.WHITE};
  transform: rotate(135deg);
`;

export const ItemIcon = styled(Icon)`
  display: flex;
  flex-wrap: wrap;

  svg {
    width: 24px;
    height: 24px;
    color: ${COLORS.BLACK};
  }
`;

Tooltip.displayName = 'Tooltip';
ComponentWrapper.displayName = 'ComponentWrapper';
Wrapper.displayName = 'Wrapper';
IconWrapper.displayName = 'IconWrapper';
IconSelected.displayName = 'IconSelected';
ItemIcon.displayName = 'ItemIcon';